/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EC2Instance { 
    image_id?: string;
    image_name?: string;
    instance_id?: string;
    instance_state?: string;
    instance_type?: string;
    az_id?: string;
    launch_time?: Date;
    name?: string;
    private_ip?: string;
    public_ip?: string;
    version?: string;
}

